import { UserActions } from "../action-types/userActionTypes";

// For Login Action

export const userSignin = (payload) => {
  return {
    type: UserActions.USER_LOGIN,
    payload,
  };
};

export const userSigninWithUserName = (payload) => {
  return {
    type: UserActions.USER_LOGIN_WITH_USERNAME,
    payload,
  };
};

export const setUserData = (payload) => {
  return {
    type: UserActions.SET_LOGIN_USER_DATA,
    payload,
  };
};

// For Logout Action

export const userLogOut = (payload) => {
  return {
    type: UserActions.USER_LOGOUT,
    payload,
  };
};

export const isUserLogOut = (payload) => {
  return {
    type: UserActions.IS_USER_LOGOUT,
    payload,
  };
};


// For Forgot Password Action

export const userForgotPassword = (payload) => {
  return {
    type: UserActions.USER_FORGOT_PASSWORD,
    payload,
  };
};


export const isForgotPassword = (payload) => {
  return {
    type: UserActions.IS_USER_FORGOT_PASSWORD,
    payload,
  };
};

// For Loader Action

export const setLoader = (payload) => {
  return {
    type: UserActions.SET_LOADER,
    payload,
  };
};

export const setLoaderUserLogin = (payload) => {
  return {
    type: UserActions.SET_LOADER_USER_LOGIN,
    payload,
  };
};

export const setLoaderUserLogOut = (payload) => {
  return {
    type: UserActions.SET_LOADER_USER_LOGOUT,
    payload,
  };
};

export const setLoaderSaveButton = (payload) => {
  return {
    type: UserActions.SET_LOADER_SAVE_BUTTON,
    payload,
  };
};

export const setLoaderUserAccountPasswordButton = (payload) => {
  return {
    type: UserActions.SET_LOADER_UPDATE_ACCOUNT_PWD_BUTTON,
    payload,
  };
};

export const setLoaderNotification = (payload) => {
  return {
    type: UserActions.SET_LOADER_NOTIFICATION,
    payload,
  };
};

// For Notification Action

export const getNotificationData = (payload) => {
  return {
    type: UserActions.GET_NOTIFICATION_LIST,
  };
};

export const setNotificationData = (payload) => {
  return {
    type: UserActions.SET_NOTIFICATION_LIST,
    payload,
  };
};

export const updateNotificationData = (payload) => {
  return {
    type: UserActions.UPDATE_NOTIFICATION_LIST,
    payload,
  };
};
